import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { componentTypes, componentFields } from 'apps/analytics';
import PageComponent from 'apps/analytics/components/PageComponent';
import PageComponentField from 'apps/analytics/components/PageComponentField';

export const getComponentId = (docNo, docVersionNo) => `GraphicItem.${docNo}.${docVersionNo}`;

export default class GraphicPageComponent extends PureComponent {
  static propTypes = {
    docNo: PropTypes.number.isRequired,
    docVersionNo: PropTypes.number.isRequired,
    parentNo: PropTypes.number.isRequired,
    parentVersionNo: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
  };

  render = () => {
    const { docNo, docVersionNo, parentNo, parentVersionNo, description } = this.props;
    return (
      <PageComponent id={getComponentId(docNo, docVersionNo)} type={componentTypes.ADVERT}>
        <PageComponentField field={componentFields.ADVERT_DOC_NO} value={docNo} />
        <PageComponentField field={componentFields.ADVERT_DOC_VERSION_NO} value={docVersionNo} />
        <PageComponentField field={componentFields.ADVERT_PARENT_DOC_NO} value={parentNo} />
        <PageComponentField field={componentFields.ADVERT_PARENT_DOC_VERSION_NO} value={parentVersionNo} />
        <PageComponentField field={componentFields.DESCRIPTION} value={description} />
      </PageComponent>
    );
  };
}
